import request from '@/config/axios'

export interface O2oOrderDetailVO {
  order: Record<string, any>
  items: Record<string, any>[]
  reservation?: Record<string, any>
  institutionName?: string
  providerName?: string
  /** 上门服务码明文（客服可见） */
  serviceVerifyCode?: string
  serviceVerifyTime?: string
  serviceVerifyProviderId?: number
  serviceVerifyProviderName?: string
  /** NONE | PENDING | VERIFIED | N/A */
  serviceVerifyStatus?: string
  /** 用户下单现场图 */
  orderImages?: string[]
  /** 师傅完工选填上传的服务现场图 */
  providerServiceImages?: string[]
}

export const getO2oOrderDetail = (id: number) => {
  return request.get<O2oOrderDetailVO>({ url: '/o2o/order/get-detail', params: { id } })
}

/**
 * O2O 服务订单分页（O2O 域接口；支持上门服务码等搜索）
 *
 * 返回结构与 trade 订单分页项对齐（items + user），另附 O2O 扩展（serviceVerifyCode 等）。
 */
export const getO2oOrderPage = (params: Record<string, any>) => {
  return request.get({ url: '/o2o/order/page', params })
}

export const forceCancelO2oOrder = (data: { id: number; reason?: string }) => {
  return request.put({ url: '/o2o/order/force-cancel', data })
}

export const forceCompleteO2oOrder = (data: { id: number; reason?: string }) => {
  return request.put({ url: '/o2o/order/force-complete', data })
}

/** 客服重新生成上门服务码，返回新码 */
export const regenerateServiceVerifyCode = (id: number) => {
  return request.put<string>({ url: '/o2o/order/regenerate-service-verify-code', params: { id } })
}
